import React, { useContext } from 'react';
import ResponseSuggestions from './ResponseSuggestions';
import ResponseSuggestionsPopup from './ResponseSuggestionsPopup';
import ScoringWidget from './ScoringWidget';
import { ChatbotContext } from '../../contexts/ChatbotContext';

/**
 * Main widget that displays all other widgets when on
 */
const ChatWidget = (props: any) => {
  // Gathering state, payload, init, and actionProvider
  const { state, payload, actionProvider, init, chatHistoryActive } = props;
  const { prompt } = useContext(ChatbotContext);

  // State to determine if Response Suggestions widget should render or not
  const showResponseSugestionsPopup = state.showResponseSugestionsPopup;

  const handleButtonClick = () => {
    actionProvider.handleUserMessage(prompt);
  };

  return (
    <>
      {/* Show ResponseSuggestions widget when it's the initial chat message*/}
      {init ? (
        <div className="widget-container mt-[1.25rem] text-base">
          {' '}
          <ResponseSuggestions handleUserAction={actionProvider.handleUserAction} />
        </div>
      ) : null}
      {/* Show the ScoringWidget for every chat response after the initial chat message and for every chat history prompt response */}
      {!init ? (
        <div className="widget-container text-base">
          <ScoringWidget payload={payload} actionProvider={actionProvider} chatHistoryActive={chatHistoryActive} />
        </div>
      ) : null}
      {(init || chatHistoryActive) && showResponseSugestionsPopup ? (
        <div className="widget-container text-base">
          <ResponseSuggestionsPopup actionProvider={actionProvider} />
        </div>
      ) : null}
      <button className="invisible" id="hidden-btn" onClick={handleButtonClick}></button>
    </>
  );
};

export default ChatWidget;
